import { render, staticRenderFns } from "./ListInputs.vue?vue&type=template&id=16fa1aa8&"
import script from "./ListInputs.vue?vue&type=script&lang=js&"
export * from "./ListInputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports